var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_795",
    "data-name": "\\uC0AC\\uAC01\\uD615 795",
    width: 26.238,
    height: 26.238,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uC2E4\\uD0DC\\uC870\\uC0AC",
    transform: "translate(0 -247)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_779",
    "data-name": "\\uC0AC\\uAC01\\uD615 779",
    width: 53,
    height: 53,
    transform: "translate(0 247)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2186",
    "data-name": "\\uADF8\\uB8F9 2186",
    transform: "translate(13.413 260.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2185",
    "data-name": "\\uADF8\\uB8F9 2185",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3633",
    "data-name": "\\uD328\\uC2A4 3633",
    d: "M13.12,0A13.119,13.119,0,1,0,26.238,13.119,13.134,13.134,0,0,0,13.12,0M19.1,16.791V11.057H17.068v7.861a7.025,7.025,0,0,1-1.28.691V14.4H13.759v5.708c-.211.019-.424.031-.64.031s-.429-.011-.64-.031V8.351H10.45V19.609a7.027,7.027,0,0,1-1.28-.691V12.807H7.141v3.984a7.018,7.018,0,1,1,11.956,0m5.994-6.037-4.159.987v0A7.945,7.945,0,0,0,13.12,5.186c-.1,0-.2,0-.3.007L13.1.915h.017a12.223,12.223,0,0,1,11.972,9.839",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.81faeeaa283a6a87ec197fce19ffcf13.svg";
export { ForwardRef as ReactComponent };